export enum EscortVehicle {
    SCOOTER = 'scooter',
    DO_DO_CAR = 'do_do_car',
    TAXI = 'taxi',
}
export enum EscortDress {
    NORMAL = 'normal',
    AO_DAI = 'ao_dai',
}
